import {
  Sprite,
  Texture,
} from 'pixi.js';
import vars from '../vars';

class BackgroundStage {
  constructor(parent) {
    this.parent = parent;

    this.sprite = new Sprite();
    this.container = new Sprite(Texture.WHITE);
    this.container.tint = 0x2c634f;
    this.container.alpha = 1;

    this.resize();

    this.sprite.addChild(this.container);
    this.parent.addChild(this.sprite);
  }

  resize() {
    this.container.width = vars.layout.FRAME_WIDTH;
    this.container.height = vars.layout.FRAME_HEIGHT;
  }
}

export default BackgroundStage;
